import { useState } from "react";
import { useLang } from "../LangContext";
import { supabase } from "../supabase";
import { CSS } from "../styles";

export default function ResetPasswordScreen() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { t } = useLang();

  const handleReset = async () => {
    if (!password || password.length < 8) { setError(t("passwordTooShort")); return; }
    if (password !== confirm) { setError(t("passwordMismatch")); return; }
    setLoading(true); setError("");
    const { error: err } = await supabase.auth.updateUser({ password });
    if (err) { setError(err.message); setLoading(false); }
    else {
      setSuccess(t("passwordUpdated"));
      setTimeout(async () => {
        await supabase.auth.signOut();
        window.location.href = window.location.origin;
      }, 2000);
    }
  };

  return (
    <div style={{ background: "#0F0E0C", minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "'DM Sans',sans-serif", padding: 24 }}>
      <style>{CSS}</style>
      <div style={{ width: "100%", maxWidth: 420 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 32, justifyContent: "center" }}>
          <div style={{ width: 38, height: 38, background: "#C9A96E", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20 }}>⬡</div>
          <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: 26, color: "#E8E2D8" }}>Travea</span>
        </div>
        <div className="card" style={{ padding: "26px 24px" }}>
          <h2 style={{ fontFamily: "'DM Serif Display',serif", fontSize: 20, fontWeight: 400, color: "#E8E2D8", marginBottom: 8 }}>{t("chooseNewPassword")}</h2>
          <p style={{ fontSize: 12, color: "#5A5450", marginBottom: 20 }}>{t("chooseNewPasswordDesc")}</p>
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <input type="password" placeholder={t("newPasswordMin")} value={password} onChange={e => setPassword(e.target.value)} />
            <input type="password" placeholder={t("confirmPassword")} value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key === "Enter" && handleReset()} />
            {error && <div style={{ background: "#2A1212", border: "1px solid #4A2020", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#FC8181" }}>{error}</div>}
            {success && <div style={{ background: "#0A2A12", border: "1px solid #1A4A22", borderRadius: 8, padding: "8px 12px", fontSize: 12, color: "#A8C97E" }}>{success}</div>}
            <button onClick={handleReset} disabled={loading} className="btn" style={{ background: "#C9A96E", color: "#0F0E0C", borderRadius: 10, padding: 13, fontSize: 14, fontWeight: 600, border: "none" }}>
              {loading ? t("savingPassword") : t("savePassword")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
